
import CustomImage from '~/components/elements/CustomImage';

export default {
  name: 'PopularBrandsItem',
  components: {CustomImage},
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
